import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { IContactUs } from "../../models/contactus/response";
import { IContactUsQuery } from "../../models/contactus/query";
import { IUpdateContactUs } from "../../models/contactus/request";

class ContactUsService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllContactUs = (query: IContactUsQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IContactUs>>({
      path: `/contactus`,
      method: "GET",
      query,
      ...params,
    });
  getContactUs = (id: number, params?: RequestParams) =>
    this.http.request<IContactUs>({
      path: `/contactus/${id}`,
      method: "GET",
      ...params,
    });

  updateContactUs = (
    id: number,
    data: IUpdateContactUs,
    params?: RequestParams
  ) =>
    this.http.request<IContactUs>({
      path: `/contactus/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteContactUs = (id: number, params?: RequestParams) =>
    this.http.request<IContactUs>({
      path: `/contactus/${id}`,
      method: "DELETE",
      ...params,
    });
}

export default ContactUsService;
